<template>
  <b-card>
    <div slot="header" v-html="caption"></div>
    <b-table
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive="sm"
      :items="items"
      :fields="captions"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <template slot="insertAt" slot-scope="data">
        <p>{{ data.item.closedAt | moment("DD-MM-YYYY HH:mm:ss") }}</p>
      </template>

      <template slot="distance" slot-scope="data">
        <h5 class="bg-tone5"><b-badge variant="light">{{data.item.distance}} m</b-badge></h5>
      </template>

      <template slot="energy" slot-scope="data">
        <h5><b-badge variant="light">{{ parseFloat(data.item.energy / 10) }} Kcal</b-badge></h5>
      </template>

      <template slot="avgspeed" slot-scope="data">
        <h5><b-badge variant="light">{{ data.item.avgspeed }} Km/h</b-badge></h5>
      </template>

      <template slot="maxpower" slot-scope="data">
        <h5><b-badge variant="light">{{ data.item.maxpower }}  watts</b-badge></h5>
      </template>

      <template slot="hrmax" slot-scope="data">
        <h5><b-badge variant="light">{{ data.item.hrmax }}  bpm</b-badge></h5>
      </template>

      <template slot="time" slot-scope="data">
        <p>{{ getTotalTime(data.item.time) }}</p>
      </template>
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="actions" slot-scope="data">
        <b-button size="sm" @click="info(data.item, data.index, $event.target)" class="mr-1" v-b-tooltip.hover title="View session details">
          <i class="icon-eye"></i> View
        </b-button>
        <b-button size="sm" @click="exportSession(data.item)" class="mr-1" v-b-tooltip.hover title="Download TCX format">
          <div v-if="!isLoading(data.item)"><i class="fa fa-download"></i> TCX</div>
          <div v-if="isLoading(data.item)"><pulse-loader :loading="isLoading(data.item)" color="white" size="6px"></pulse-loader></div>
        </b-button>
      </template>
    </b-table>
    <nav>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      />
    </nav>
  </b-card>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: "c-table",
   components: {
    PulseLoader
  },
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 15
    },
    dark: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      currentPage: 1,
      loading: false,
      downloadItem: null
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    info(item){
      this.$emit('on-select',item)
    },
    isLoading(item){
      return this.loading && (this.downloadItem === item.id)
    } ,
    exportSession(item){
      this.downloadItem = item.id
      this.loading = true
      this.$store.dispatch('exportSession', { sessionId: item.id}).then(response => {
        if(response.status && response.status === 200){
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const name = this.$moment(item.closedAt * 1000).format("DD-MM-YYYY-HH:mm");
          link.href = url;
          link.setAttribute('download', name+'.tcx');
          document.body.appendChild(link);
          link.click();
          this.loading = false
        }else{
          this.showErrorMsg({message: 'Export session error'});
          this.loading = false
        }

      }, error => {
        console.log(error);
        this.loading = false
        this.showErrorMsg({message: error});
      })
    },
    getTotalTime(duration) {
      var t = duration * 1000;
      var d = this.$moment.duration(t);
      var s = Math.floor(d.asHours()) + this.$moment.utc(t).format(":mm:ss");
      return s;
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    }
  },
    notifications: {
        showErrorMsg: { 
            title: 'Operation Failed',
            message: 'Failed to authenticate',
            type: 'error',
        },
        showSuccessMsg: { 
            title: 'Export',
            message: 'Operation success',
            type: 'success',
            duration: 8000
        }
    }
};
</script>
<style scoped>
.bg-tone5 .badge.badge-light{background:#7CFEF0 !important;}
</style>


// WEBPACK FOOTER //
// src/components/utils/Table.vue